<wo-site-input
  data-e2e="site filter list"
  [formControl]="control.control"
  [customerIds]="customerIds"
  [placeholder]="'iss-wo-common.label.all-sites' | translate"
  [multi]="multi"
  [withAll]="multi"
/>
